import React from 'react'
import { Content } from 'components/SwitchAndGauge/DashDrawer/Sections'
import { Header, Paragraph } from 'components/patterns'
import strings from 'utils/strings'
import styled from '@emotion/styled'
import { StyledViewWrap } from './style'

const ErrorView = () => {
  return (
    <StyledViewWrap>
      <Content>
        <StyledHeader type="h3">{strings.switch_search_time_out}</StyledHeader>
        <NotFoundMessage>
          <StyledIcon />
          <Paragraph>{strings.qr_time_out}</Paragraph>
        </NotFoundMessage>
      </Content>
    </StyledViewWrap>
  )
}

export default ErrorView

const StyledHeader = styled(Header)`
  font-weight: normal;
`

const NotFoundMessage = styled.div`
  display: flex;
  margin-top: 8px;
  flex-direction: row;

  ${Paragraph} {
    flex: 83%;
  }
`

const SvgComponent = (props) => (
  <svg
    width={20}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.71 14.82 11.84 1.06a2.09 2.09 0 0 0-3.63 0L.31 14.82A2.12 2.12 0 0 0 2.1 18h15.8a2.12 2.12 0 0 0 1.81-3.18zM11 14.5H9v-2h2v2zm0-5a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0v2z"
      fill="#4F5764"
      fillOpacity={0.87}
    />
  </svg>
)

const StyledIcon = styled(SvgComponent)`
  flex: 1;
`
